import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { formatDecimalHours } from 'modules/project_management/components/Schedule/Body/ScheduleItem/utils'

interface Props {
  plannedHours: number
}
const PlannedHoursHover = ({ plannedHours }: Props) => {
  return (
    <Box paddingBottom="s8">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="200" weight="bold">
          {i18n.t('project_management.planning.header_cells_hover.planned_hours')}
        </Text>
        <Text size="200" weight="bold">
          {formatDecimalHours(plannedHours)}{' '}
          {i18n.t('project_management.planning.employee_info.hours_unit')}
        </Text>
      </Box>
    </Box>
  )
}

export default PlannedHoursHover
